import type { ReactElement, ReactNode, JSX } from 'react';
import type React from 'react';
import { forwardRef } from 'react';

import * as Icons from './IconList';
import { allIconNames } from './util';

export type IconName = keyof typeof Icons;

interface IconProps {
    color?: string;
    size?: string | number;
    className?: string;
    titleAccess?: string;
}

const makeIcon = (iconName: IconName) =>
    forwardRef(
        (
            { color = 'inherit', size = '24px', className, ...props }: IconProps,
            ref: React.Ref<SVGSVGElement>,
        ): JSX.Element => {
            const Icon = Icons[iconName];
            const numericSize = typeof size === 'number' ? size : parseInt(size, 10) || 24;
            return (
                <Icon
                    htmlColor={color}
                    className={className}
                    style={{ fontSize: size, verticalAlign: 'middle' }}
                    size={numericSize}
                    {...props}
                    ref={ref}
                />
            );
        },
    );

type IconDict = {
    [k in IconName]: (props: IconProps) => ReactElement<any> | ReactNode | null | undefined;
};

const Icon = (): IconDict => {
    const iconDict: IconDict = {} as IconDict;
    for (const iconName of allIconNames) {
        iconDict[iconName] = makeIcon(iconName);
    }
    return iconDict;
};

export default Icon();
